const opacities = {
    0: 0,
    20: 0.2,
    30: 0.3,
    50: 0.5,
    100: 1,
};

export default opacities;
